import Modal from '@components/Modal';
import useNoodleApi from '@hooks/useNoodleApi';
import * as tsClient from '@/tsClient';
import ProgressIndicator from '@/components/ProgressIndicator';
import { useEffect } from 'react';
import { useQuestionnaireContext } from '@/components/Questionnaire/QuestionnaireProvider';
import s from './ResponseDebugger.module.scss';
import SingleResponse from './SingleResponse';
import parseFieldKey from '../../helpers/parseFieldKey';

type Props = {
  onClose: () => void;
  fieldKey: string;
  row: number | null;
};

const ResponseDebuggerModal: React.FC<Props> = ({ onClose, fieldKey, row }) => {
  const {
    questionnaireId,
  } = useQuestionnaireContext();

  const { getData: getFieldResponseDebug, data: fullResponse } = useNoodleApi(tsClient.questionnaires.getFieldResponseDebug, {
    toastOnError: true,
  });

  useEffect(() => {
    const parsedFieldKey = parseFieldKey(fieldKey);

    getFieldResponseDebug({
      fieldKey: parsedFieldKey.fieldKey,
      listFieldKey: parsedFieldKey.listFieldKey ?? undefined,
      page: 1,
      perPage: 1_000,
      questionnaireId,
      row: parsedFieldKey.rowIndex ?? undefined,
    });
  }, [getFieldResponseDebug, questionnaireId, fieldKey, row]);

  return (
    <Modal hideBottomInset title={'Debug'} onClose={onClose} isWide>
      <div className={s.modalWrapper}>
        {!fullResponse && (
          <ProgressIndicator />
        )}
        {(fullResponse && fullResponse.items.length === 0) && (
          <div className={s.noResponses}>
            No responses found for this field.
          </div>
        )}
        {fullResponse && fullResponse.items.map((response) => (
          <SingleResponse key={response.id} response={response} />
        ))}
      </div>
    </Modal>
  );
};

export default ResponseDebuggerModal;
